<div class="wrapper">
  <p class="brodtext-medium-14">
    Där multipla värden kan väljas söker du genom att skriva minst ett tecken. Sökningen börjar så fort du skriver in <br>
    det första tecknet och uppdateras kontinuerligt medan du skriver fler tecken. Detta gör att du får omedelbar <br>
    feedback och kan se resultat som matchar din sökning direkt. Sökningen görs på inmatad text oavsett placering i <br>
    sökresultatet. När du kryssat i dina val, avsluta genom att klicka på krysset eller utanför dropdown-funktionen.
  </p>
  <form [formGroup]="searchForm">
    <div class="dropdowns">
      @if (searchType === searchTypes.GENERAL) {
        <div>
          <label for="">Standardnamn för smittämne <span class="text-danger">*</span></label>
          <p-multiSelect
            formControlName="species"
            [options]="(standardNamnService.smittamne | async | orderBy: 'standardNamn') || undefined"
            optionLabel="standardNamn"
            placeholder="Välj ett smittämne"
            [filter]="true"
            filterBy="standardNamn"
            [virtualScroll]="true"
            [virtualScrollItemSize]="40"
            [showToggleAll]="false"
          />
        </div>
      } @else if (searchType === searchTypes.SPECIFIC) {
        <div>
          <label for="">Standardnamn för smittämne <span class="text-danger">*</span></label>
          <p-select
            formControlName="species"
            [options]="(standardNamnService.smittamne | async | orderBy: 'standardNamn') || undefined"
            optionLabel="standardNamn"
            placeholder="Välj ett smittämne"
            [filter]="true"
            filterBy="standardNamn"
            [virtualScroll]="true"
            [virtualScrollItemSize]="40"
          />
        </div>
      }
      <div>
        <label for="">Provtagningsår <span class="text-danger">*</span></label>
        <p-select
          formControlName="sampleYear"
          [options]="searchableYears"
          placeholder="Välj provtagningsår"
          optionDisabled="disabled"
        />
      </div>
      <div>
        <label for="">Analys</label>
        <p-multiSelect
          formControlName="analysis"
          [options]="(standardNamnService.analyser | async | orderBy: 'standardNamn') || undefined"
          optionLabel="standardNamn"
          placeholder="Välj analys"
        />
      </div>
      <div>
        <label for="">Provmaterial</label>
        <p-multiSelect
          formControlName="sampleMaterial"
          [options]="(standardNamnService.provmaterial | async) || undefined"
          optionLabel="standardNamn"
          placeholder="Välj provmaterial"
        />
      </div>
      @if (searchType === searchTypes.GENERAL) {
        <div>
          <label for="">Antibiotika</label>
          <p-multiSelect
            formControlName="antibiotics"
            [options]="(standardNamnService.antibiotika | async) || undefined"
            optionLabel="standardNamn"
            placeholder="Välj antibiotika"
          />
        </div>
      }
      <div>
        <label for="">Laboratorium</label>
        @if (sessionService.isInternUser) {
          <p-multiSelect formControlName="labCodes" [options]="SMEs" placeholder="Välj labb" optionLabel="label" />
        } @else {
          <div class="d-flex">
            <div class="me-4"><input formControlName="externalLabChoice" value="all" type="radio" name="externalLabChoice" id="all" /><label class="ms-2">Alla</label></div>
            <div><input formControlName="externalLabChoice" value="own" type="radio" name="externalLabChoice" id="ownLab" /><label class="ms-2">Eget lab</label></div>
          </div>
        }
      </div>
      <div>
        <label for="">Åldersgruppsindelning enligt</label>
        <p-select
          formControlName="ageIntervalStandard"
          [options]="ageIntervalStandardOptions"
          placeholder="Välj ålderindelning"
        />
      </div>
      <div>
        <label for="">Kön</label>
        <p-multiSelect formControlName="gender" [options]="['Man', 'Kvinna', 'Okänt']" placeholder="Välj kön" />
      </div>
      <div>
        <label for="">Åldersintervall</label>
        <p-select
          formControlName="ageSpan"
          [options]="currentAgeIntervals"
          placeholder="Välj Åldersintervall"
          [showClear]="true"
        />
      </div>
    </div>
    <div class="mb-4">
      <label for="">Provtagningsdatum</label>
      <br />
      <p-datepicker
        formControlName="sampleDateStart"
        dateFormat="yy-mm-dd"
        icon="fa-solid fa-calendar"
        [showIcon]="true"
        [showClear]="true"
        [maxDate]="maxStartDate"
        dataType="string"
        placeholder="Från"
        [defaultDate]="defaultDate"
      >
      </p-datepicker>
      <span class="m-2"></span>
      <p-datepicker
        formControlName="sampleDateEnd"
        dateFormat="yy-mm-dd"
        icon="fa-solid fa-calendar"
        [showIcon]="true"
        [showClear]="true"
        [minDate]="minEndDate"
        [maxDate]="maxEndDate"
        dataType="string"
        placeholder="Till"
        [defaultDate]="minEndDate"
      >
      </p-datepicker>
    </div>
  </form>
  <div class="d-flex justify-content-between">
    <app-button buttonStyle="secondary" text="Nollställ sökparametrar" type="button" (click)="resetForm()"></app-button>
    <app-button
      buttonStyle="primary"
      icon="search"
      text="Sök"
      type="button"
      [disabled]="
        (searchType !== searchTypes.NAMNARDATA && !searchForm.controls.species.dirty) ||
        !searchForm.controls.sampleYear.dirty
      "
      [callback]="performSearch"
    ></app-button>
  </div>

  @if (results) {
    <div class="results">
      <h2 class="mb-4">Sökresultat - Sammanställning</h2>
      <app-search-params></app-search-params>
      <h4>Resultat</h4>
      <div class="result-grid">
        <div>
          <div>Antal fynd</div>
          <div>{{ results?.fyndCount ? formatBigNumber(results.fyndCount) : 0 }}</div>
        </div>
        <div *ngIf="searchType === searchTypes.NAMNARDATA">
          <div>Antal positiva fynd</div>
          <div>{{ results?.positive ? formatBigNumber(results.positive) : 0 }}</div>
        </div>
        <div *ngIf="searchType === searchTypes.NAMNARDATA">
          <div>Antal negativa fynd</div>
          <div>{{ results?.negative ? formatBigNumber(results.negative) : 0 }}</div>
        </div>
      </div>
      @if (!(globalStateService.csvDownloadInProgress | async)) {
        <div class="buttons">
          <div *ngIf="searchType === searchTypes.SPECIFIC" class="button-wrapper">
            <app-button
              text="Sammanställ antibiotikaresistens i tabell"
              icon="calculator"
              buttonStyle="primary"
              (click)="calc()"
              [disabled]="results?.fyndCount === 0"
            ></app-button>
            <div *ngIf="results?.fyndCount > 0" class="link" (click)="getCalcCsv()">
              <i class="fa fa-download"></i> Ladda ner sammanställd tabell i CSV-fil
            </div>
          </div>
          <div class="button-wrapper">
            <app-button
              text="Visa sökresultatets provlista i detalj"
              icon="up-right-from-square"
              buttonStyle="secondary"
              [disabled]="results?.fyndCount === 0"
              (click)="searchAndGroupByProv()"
            ></app-button>
            <div *ngIf="results?.fyndCount > 0" class="link" (click)="getRowDataCsv()">
              <i class="fa fa-download"></i> Ladda ner provlista i CSV-fil
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (globalStateService.csvDownloadInProgress | async) {
    <div class="downloading">
      <p class="download-in-progress"><i class="fa-solid fa-spinner fa-spin"></i> Pågående nedladdning av CSV-fil</p>
      <p>
        Du kan följa nedladdningen i toppen av högra hörnet på hemsidan. Du kan röra dig fritt i Svebar under
        nedladdningen, undvik dock att genomföra en ny sökning medan nedladdning pågår.
      </p>
    </div>
  }
  @if (showSkeleton && !results) {
    <div class="mt-4">
      <p-skeleton height="4rem" styleClass="mb-2" />
      <p-skeleton width="10rem" height="10rem" styleClass="mb-2" />
      <p-skeleton width="20rem" height="5rem" styleClass="mb-2" />
    </div>
  }

  @if (showCalc) {
    <app-antibiotic-calc></app-antibiotic-calc>
  }
</div>
